import React, {useRef} from 'react';
import {Button, Card, Descriptions, Modal, PageHeader, Space, Spin} from 'antd';
import _ from 'lodash';

import './SettingsPage.less';

import CorpFormModal from './CorpFormModal';
import {DeleteOutlined, EditOutlined, PlusOutlined} from '@/icons';
import {useAsyncRetry} from 'react-use';
import {deleteCorp, getCorp} from '@/api/settings';
import {get as getData} from './utils';
import {useEditAuthService} from '@/page/admin/adminService';
import {SecurityTextView} from '@/component';

const CorpSetting = () => {
    const formModalRef = useRef();

    const editable = useEditAuthService(['global:sys_corp:w']);

    const {loading, value, retry} = useAsyncRetry(() => {
        return getCorp();
    }, []);

    const corps = _.get(value, 'data');

    function get(corp, key) {
        return _.get(corp, key, '尚未定义');
    }

    function onAddClick() {
        formModalRef.current.showModal();
    }

    function onEditClick(corp) {
        return () => {
            formModalRef.current.showModal(corp);
        };
    }

    function onDeleteClick(corp) {
        return () => {
            Modal.confirm({
                title: '警告',
                content: `确定要删除企业「${corp.corpName}」?`,
                onOk: () => {
                    deleteCorp(corp.id).then(json => {
                        console.log(json);
                        retry();
                    });
                },
            });
        };
    }

    return (
        <PageHeader
            title="企业设置"
            // extra={
            //     editable && (
            //         <Button type="primary" icon={<PlusOutlined />} onClick={onAddClick}>
            //             添加企业
            //         </Button>
            //     )
            // }
            style={{overflowY: 'auto'}}
        >
            <Spin spinning={loading}>
                <Space direction="vertical" size="large" style={{display: 'flex'}}>
                    {!_.isEmpty(corps) &&
                        corps.map(corp => (
                            <Card
                                key={corp.id}
                                title={get(corp, 'corpName')}
                                hoverable
                                // extra={
                                //     editable && (
                                //         <Space>
                                //             <Button
                                //                 type="primary"
                                //                 icon={<EditOutlined />}
                                //                 onClick={onEditClick(corp)}
                                //             />
                                //             <Button
                                //                 danger
                                //                 icon={<DeleteOutlined />}
                                //                 onClick={onDeleteClick(corp)}
                                //             />
                                //         </Space>
                                //     )
                                // }
                            >
                                <Descriptions
                                    size="small"
                                    column={1}
                                    bordered
                                    className="settings-page"
                                >
                                    <Descriptions.Item label="企业ID">
                                        {get(corp, 'id')}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业名称">
                                        {get(corp, 'corpName')}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业别名">
                                        {get(corp, 'corpAlias')}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业微信 ID">
                                        {get(corp, 'corpIdAtWecom')}
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业微信通讯录 Secret">
                                        <SecurityTextView text={_.get(corp, 'contactSecret')} />
                                    </Descriptions.Item>
                                </Descriptions>

                                <Descriptions
                                    size="small"
                                    column={1}
                                    bordered
                                    className="settings-page"
                                    style={{marginTop: 10}}
                                >
                                    <Descriptions.Item label="企业微信通讯录事件回调 Token">
                                        <SecurityTextView
                                            text={_.get(corp, 'contactCallbackToken')}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业微信通讯录事件回调 EncodingAESKey">
                                        <SecurityTextView
                                            text={_.get(corp, 'contactCallbackSecret')}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="企业微信通讯录事件回调 url">
                                        {get(corp, 'contactCallbackUrl')}
                                    </Descriptions.Item>
                                </Descriptions>

                                <Descriptions
                                    size="small"
                                    column={1}
                                    bordered
                                    className="settings-page"
                                    style={{marginTop: 10}}
                                >
                                    <Descriptions.Item label="会话留存 Secret">
                                        <SecurityTextView
                                            text={_.get(corp, 'conversationSecret')}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="客户联系 Secret">
                                        <SecurityTextView text={_.get(corp, 'customerSecret')} />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="客户回调 Token">
                                        <SecurityTextView
                                            text={_.get(corp, 'customerCallbackToken')}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="客户回调 Secret">
                                        <SecurityTextView
                                            text={_.get(corp, 'customerCallbackSecret')}
                                        />
                                    </Descriptions.Item>
                                    <Descriptions.Item label="客户回调 url">
                                        {_.get(corp, 'customerCallbackUrl')}
                                    </Descriptions.Item>
                                </Descriptions>
                            </Card>
                        ))}
                </Space>
            </Spin>
            <CorpFormModal ref={formModalRef} reload={retry} />
        </PageHeader>
    );
};

export default CorpSetting;
